import React from 'react';

const Edit = ({ svgRef, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" ref={svgRef} {...props}><g><g><g><path fill="#53b3e3" d="M0 15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z"/></g><g><g><path fill="#fff" d="M10.99 19.577L9 19.842l.268-1.964 6.022-5.945 1.722 1.7zm6.623-6.538l-1.721-1.7 1.18-1.165a.605.605 0 0 1 .849 0l.873.861a.587.587 0 0 1 0 .839z"/></g><g><path fill="#fff" d="M9 20.42h11.73v.579H9z"/></g></g></g></g></svg>
);

export default Edit



// WEBPACK FOOTER //
// ./src/common/icons/Edit.js